/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Info_ProposalInputs */

const en_footer_info_proposal = /** @type {(inputs: Footer_Info_ProposalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proposal`)
};

/**
* | output |
* | --- |
* | "Proposal" |
*
* @param {Footer_Info_ProposalInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_info_proposal = /** @type {((inputs?: Footer_Info_ProposalInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Info_ProposalInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_info_proposal(inputs)
});